export default "__VITE_ASSET__ba996480__"